/* eslint-disable max-len */
import { gql } from "graphql-tag";

export const LIST_USERS_QUERY = gql`
  query AdminListUsersQuery($id: ID, $name: String, $loginEmail: String, $loginPhone: String) {
    adminApplicants(id: $id, name: $name, loginEmail: $loginEmail, loginPhone: $loginPhone) {
      id
      loginEmail
      loginPhone
      isArchived

      profile {
        firstName
        lastName
      }

      organization {
        id
        name
      }

      interests(isComplete: null) {
        id
      }
    }
  }
`;

export const DETAILED_LIST_USERS_QUERY = gql`
  query AdminDetailedListUsersQuery($id: ID, $name: String, $loginEmail: String, $loginPhone: String) {
    adminApplicants(id: $id, name: $name, loginEmail: $loginEmail, loginPhone: $loginPhone) {
      id
      loginEmail
      loginPhone

      emailVerified
      phoneVerified

      isArchived

      profile {
        id
        firstName
        lastName
      }

      organization {
        id
        name
      }

      userRoles {
        role
      }

      interests(isComplete: null) {
        id
        submittedAt
        status {
          name
          changedAt
        }

        householdMember0FirstName
        householdMember0LastName
        
        householdMember0Email
        
        householdMember0PrimaryPhone
        householdMember0PrimaryPhoneType
        
        householdMember0SecondaryPhone
        householdMember0SecondaryPhoneType

        interestList {
          id
          name

          property {
            id
            name
          }

          organization {
            id
            name
          }
        }
      }
    }
  }
`;

export const MergeAccountsMutation = gql`
  mutation AdminMergeAccountsMutation($ids: [ID!]!, $firstName: String, $lastName: String, $loginEmail: String, $loginPhone: String) {
    adminMergeAccounts(ids: $ids, firstName: $firstName, lastName: $lastName, loginEmail: $loginEmail, loginPhone: $loginPhone) {
      id
      loginEmail
      loginPhone
      profile {
        firstName
        lastName
      }
    }
  }
`;

export const ARCHIVE_ACCOUNT_MUTATIION = gql`
  mutation AdminArchiveAccountMutation($id: ID!) {
    adminArchiveAccount(id: $id) {
      id
      loginEmail
      loginPhone
    }
  }
`;

export const RESTORE_ACCOUNT_MUTATIION = gql`
  mutation AdminRestoreAccountMutation($id: ID!) {
    adminRestoreAccount(id: $id) {
      id
      loginEmail
      loginPhone
    }
  }
`;

export const UpdateAccountMutation = gql`
  mutation AdminUpdateAccountMutation($id: ID!, $user: AdminUserInput!, $profile: AdminUserProfileInput!, $roles: [PostgresUserRole!]!) {
    adminUpdateAccount(id: $id, user: $user, profile: $profile, roles: $roles) {
      id
    }
  }
`;

export const CreateAccountMutation = gql`
  mutation AdminCreateAccountMutation($user: AdminUserInput!, $profile: AdminUserProfileInput!, $roles: [PostgresUserRole!]!) {
    adminCreateAccount(user: $user, profile: $profile, roles: $roles) {
      id
    }
  }
`;
